import GroupedImages from './GroupedImages';
export default GroupedImages;